var render, staticRenderFns
import script from "./BitrixPriceForm.vue?vue&type=script&lang=js&"
export * from "./BitrixPriceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d31bfe6",
  null
  
)

export default component.exports